import { useSelector } from 'react-redux';

export default function useScriptDetails() {
  return useSelector(state => state.layout.scriptDetails);
}
